import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class EmptyPageService {
  private win;
  public open() {
    this.win = window.open();
  }
  public render(html: string) {
    this.win.document.open();
    this.win.document.write(html);
    this.win.document.close();
  }
  public print() {
    setTimeout(() => {
      this.win.print();
    }, 100);
  }
}
